// Sidebar.jsx
// Collapsible left navigation
// Add new views/reports here — nothing else needs to change

import React, { useState } from 'react';
import useStore from '../store';

const NAV_ITEMS = [
  {
    id:    'charts',
    label: '📈 Charts',
    type:  'single',   // no submenu
  },

  {
      id:    'stocks',
      label: '🏢 Stock Master',
      type:  'single',
  },

  {
    id:    'exchanges',
    label: '🏛️ Exchanges',
    type:  'single',
  },

   {
    id:    'watchlists',
    label: '⭐ Watchlists',
    type:  'single',
  },

  {
    id:    'reports',
    label: '📊 Reports',
    type:  'group',    // has submenu
    children: [
      { id: 'report_ema_crossover', label: 'EMA Crossover' },
      { id: 'report_sr',            label: 'Support / Resistance' },
      { id: 'live_alerts',          label: '🔴 Live Alerts' },
      { id: 'report_builder',       label: '🔧 Report Builder' },  // ← add this
      { id: 'report_ema_strategy',  label: '📐 EMA Strategy Backtest' },
      // Add new reports here — nothing else changes
    ],
  },
  {
    id:    'trades',
    label: '📋 Trades',
    type:  'single',
  },

  {
    id:    'settings',
    label: '⚙️ Settings',
    type:  'single',
},
];

function Sidebar() {
  const { activeView, setActiveView } = useStore();
  const [collapsed, setCollapsed]     = useState(false);
  const [openGroups, setOpenGroups]   = useState({ reports: true });

  const toggleGroup = (id) => {
    setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (collapsed) {
    return (
      <div style={styles.collapsedSidebar}>
        <button
          onClick={() => setCollapsed(false)}
          style={styles.collapseBtn}
          title="Expand sidebar"
        >
          ▶
        </button>
      </div>
    );
  }

  return (
    <div style={styles.sidebar}>

      {/* Collapse button */}
      <div style={styles.collapseRow}>
        <span style={styles.appName}>Trading</span>
        <button
          onClick={() => setCollapsed(true)}
          style={styles.collapseBtn}
          title="Collapse sidebar"
        >
          ◀
        </button>
      </div>

      {/* Nav items */}
      <nav style={styles.nav}>
        {NAV_ITEMS.map((item) => {

          if (item.type === 'single') {
            return (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === 'charts') {
                    useStore.getState().setMarkersConfig({
                      enabled:         false,
                      fetchFn:         null,
                      filters:         {},
                      markersBySymbol: null,
                    });
                  }
                  setActiveView(item.id);
                }}
                style={{
                  ...styles.navItem,
                  ...(activeView === item.id ? styles.navItemActive : {})
                }}
              >
                {item.label}
              </button>
            );
          }

          if (item.type === 'group') {
            return (
              <div key={item.id}>
                {/* Group header */}
                <button
                  onClick={() => toggleGroup(item.id)}
                  style={styles.groupHeader}
                >
                  <span>{item.label}</span>
                  <span>{openGroups[item.id] ? '▾' : '▸'}</span>
                </button>

                {/* Group children */}
                {openGroups[item.id] && (
                  <div style={styles.groupChildren}>
                    {item.children.map((child) => (
                      <button
                        key={child.id}
                        onClick={() => setActiveView(child.id)}
                        style={{
                          ...styles.childItem,
                          ...(activeView === child.id
                            ? styles.navItemActive : {})
                        }}
                      >
                        {child.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          return null;
        })}
      </nav>

    </div>
  );
}

const styles = {
  sidebar: {
    width:           '180px',
    minWidth:        '180px',
    backgroundColor: '#ffffff',
    borderRight:     '1px solid #e0e0e0',
    display:         'flex',
    flexDirection:   'column',
    overflow:        'hidden',
  },
  collapsedSidebar: {
    width:           '32px',
    minWidth:        '32px',
    backgroundColor: '#ffffff',
    borderRight:     '1px solid #e0e0e0',
    display:         'flex',
    justifyContent:  'center',
    paddingTop:      '8px',
  },
  collapseRow: {
    display:        'flex',
    justifyContent: 'space-between',
    alignItems:     'center',
    padding:        '10px 10px 6px 12px',
    borderBottom:   '1px solid #e0e0e0',
  },
  appName: {
    color:      '#131722',
    fontWeight: 'bold',
    fontSize:   '14px',
  },
  collapseBtn: {
    background: 'none',
    border:     'none',
    color:      '#666',
    cursor:     'pointer',
    fontSize:   '12px',
    padding:    '2px 4px',
  },
  nav: {
    display:       'flex',
    flexDirection: 'column',
    padding:       '8px 0',
    overflowY:     'auto',
  },
  navItem: {
    display:         'block',
    width:           '100%',
    padding:         '8px 16px',
    backgroundColor: 'transparent',
    color:           '#555',
    border:          'none',
    textAlign:       'left',
    cursor:          'pointer',
    fontSize:        '13px',
  },
  navItemActive: {
    backgroundColor: '#e8f0fe',
    color:           '#2962ff',
    borderLeft:      '3px solid #2962ff',
    paddingLeft:     '13px',
  },
  groupHeader: {
    display:         'flex',
    justifyContent:  'space-between',
    alignItems:      'center',
    width:           '100%',
    padding:         '8px 16px',
    backgroundColor: 'transparent',
    color:           '#555',
    border:          'none',
    textAlign:       'left',
    cursor:          'pointer',
    fontSize:        '13px',
  },
  groupChildren: {
    backgroundColor: '#f9f9f9',
  },
  childItem: {
    display:         'block',
    width:           '100%',
    padding:         '6px 16px 6px 28px',
    backgroundColor: 'transparent',
    color:           '#666',
    border:          'none',
    textAlign:       'left',
    cursor:          'pointer',
    fontSize:        '12px',
  },
};

export default Sidebar;